var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 20 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 25.4409C24.6667 29.0778 23.4726 32.5658 21.3472 35.1375C19.2218 37.7092 16.3391 39.1539 13.3333 39.1539C10.3275 39.1539 7.44487 37.7092 5.31946 35.1375C3.19404 32.5658 2 29.0778 2 25.4409C2 15.8417 9.93333 3.5 13.3333 3.5C16.7333 3.5 24.6667 15.8417 24.6667 25.4409Z",
    stroke: "#6FBA80",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 17.2148V44.6409",
    stroke: "#6FBA80",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 25.4404C18.9997 26.3408 18.8531 27.2324 18.5683 28.0643C18.2835 28.8961 17.8661 29.652 17.3399 30.2887C16.8137 30.9253 16.1891 31.4304 15.5015 31.775C14.814 32.1195 14.0772 32.2969 13.333 32.2969",
    stroke: "#6FBA80",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3331 26.8115C12.1308 26.8115 10.9777 26.2336 10.1276 25.2049C9.27742 24.1762 8.7998 22.781 8.7998 21.3262",
    stroke: "#6FBA80",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.f79e1c4e50760810d6280a5812ca2784.svg";
export { ForwardRef as ReactComponent };